//
// Copyright 2026 DXOS.org
//
import { fromBinary, toBinary } from '@bufbuild/protobuf';
import * as Schema from 'effect/Schema';
import * as SchemaTransformation from 'effect/SchemaTransformation';
import { ErrorSchema } from './buf/proto/gen/dxos/error_pb.js';
import { decodeError, encodeError } from './errors/encoding.js';
/** Encodes a buf message as protobuf bytes on the wire. */
export const bufMessage = (messageSchema) => Schema.Uint8Array.pipe(Schema.decodeTo(Schema.declare((_) => true), SchemaTransformation.transform({
    decode: (bytes) => fromBinary(messageSchema, bytes),
    encode: (value) => toBinary(messageSchema, value),
})));
/**
 * Error channel schema for service RPCs.
 * Encodes via the `dxos.error.Error` protobuf message and reconstructs registered error
 * classes on decode so typed errors cross the RPC boundary.
 */
export const serviceError = Schema.Uint8Array.pipe(Schema.decodeTo(Schema.declare((value) => value instanceof Error), SchemaTransformation.transform({
    decode: (bytes) => decodeError(fromBinary(ErrorSchema, bytes)),
    encode: (error) => toBinary(ErrorSchema, encodeError(error)),
})));
//# sourceMappingURL=service-rpc.js.map